import React, { useEffect } from "react";
import { DatosDRCApi } from "../api/DatosDRCApi";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";

export const useDatosDRC = (analisisDetalle) => {
    const [mostrarModal, setMostrarModal] = React.useState(false);
    const [datosDRC, setDatosDRC] = React.useState([]);
    
    const { getLaboratoristas, cargando } = DatosDRCApi();

    const [datoDRCEditar, setDatoDRCEditar] = React.useState(null);

    useEffect(() => {
        if (analisisDetalle && analisisDetalle.datos_drc) {
            setDatosDRC(analisisDetalle.datos_drc || []);
        }
    }, [analisisDetalle && analisisDetalle.datos_drc]);

    // Async loaders
    const loadLaboratoristas = useDebouncedAsyncSelect(function (search) {
        return getLaboratoristas({ search: search });
    });

    const AgregarDatoDRC = (data) => {
        setDatosDRC((prev) => [...prev, data]);
    };

    const SeleccionarDatoDRCParaEditar = (dato, index) => {
        setDatoDRCEditar({ ...dato, index });
        setMostrarModal(true);
    };

    const ActualizarDatoDRC = (data) => {
        setDatosDRC((prev) => {
            const newDatos = [...prev];
            newDatos[datoDRCEditar.index] = data;
            return newDatos;
        });
        setDatoDRCEditar(null);
    };

    const EliminarDatoDRC = (index) => {
        setDatosDRC((prev) => {
            const newDatos = [...prev];
            newDatos.splice(index, 1);
            return newDatos;
        });
    };

    const closeModal = () => {
        setMostrarModal(false);
        setDatoDRCEditar(null);
    };

    return {
        mostrarModal,
        setMostrarModal,
        closeModal,
        loadLaboratoristas,
        datosDRC,
        setDatosDRC,
        AgregarDatoDRC,
        ActualizarDatoDRC,
        EliminarDatoDRC,
        datoDRCEditar,
        setDatoDRCEditar,
        SeleccionarDatoDRCParaEditar,
        cargando,
    };
};
